import { render, staticRenderFns } from "./EarlyWarningDisposalCard.vue?vue&type=template&id=37063338&scoped=true"
import script from "./EarlyWarningDisposalCard.vue?vue&type=script&lang=js"
export * from "./EarlyWarningDisposalCard.vue?vue&type=script&lang=js"
import style0 from "./EarlyWarningDisposalCard.vue?vue&type=style&index=0&id=37063338&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37063338",
  null
  
)

export default component.exports